export const VIEWED_QUOTA_COMPONENT_TABS = 'VIEWED_QUOTA_COMPONENT_TABS';
